module.exports = __webpack_public_path__ + "static/media/border-inner.e102eb22.svg";